import React, { useContext } from "react";
import { LearningActivityCard } from "Components/Module/LearningActivityItem";
import ActivityDescription from "Components/Module/LearningActivityItem/Description";
import {
  getCardTitle,
  CardNoImage,
} from "Components/Module/LearningActivityItem/functions";
import { CARD_IMAGE_HEIGHT } from "Components/Module/LearningActivityItem/constants";
import { SurveyProgramChips } from "./CardChips";
import { SurveyProgramActions } from "./CardActions";
import { useCourseCompletion } from "../../../../functions";
import LangContext from "../../../../langContext";

const SurveyProgramCard = (props) => {
  const languageContext = useContext(LangContext);
  const { course, isPortalOverview, isPreview, displayImage } = props;

  const [completed, setCompleted] = useCourseCompletion(course);
  const cardTitle = languageContext(course.title);

  const imageRenderer = displayImage
    ? () => {
        return <div style={{ height: CARD_IMAGE_HEIGHT }}></div>;
      }
    : () => {
        return <CardNoImage />;
      };

  return (
    <LearningActivityCard
      id={`learningActivityCard${course.courseId}`}
      title={cardTitle}
      type={course.type}
      displayImage={displayImage}
      imageRenderer={imageRenderer}
      displayIcon={false}
      chips={
        <SurveyProgramChips
          course={course}
          completed={completed}
          languageContext={languageContext}
        />
      }
      content={
        <ActivityDescription
          description={languageContext(course.itemDescription)}
        />
      }
      actions={
        <SurveyProgramActions
          course={course}
          isPreview={isPreview}
          languageContext={languageContext}
        />
      }
    />
  );
};

export default SurveyProgramCard;
